import {
  call,
  fork,
  put,
  takeLatest
} from "redux-saga/effects";
import {
  SAVE_USER_INFO,
  UPDATE_USER_IMAGE,
  SAVE_CACHE,
} from "../actions/actionConstants";
import { imageTypesMap } from "../utils/imageTypes";
import Data from "../utils/data";

function* saveOrgData(orgData, date) {
  yield put({ type: SAVE_CACHE, field: "orgData", data: orgData, requestDate: date });
}

function* getData({ userInfo: { organization_id: orgId } }) {
  const date = new Date();
  const orgData = yield call(Data.getOrgDataById, orgId);
  yield fork(saveOrgData, orgData, date);
  const logo = orgData.images.find(({ type, shop_id: shopId }) => type === imageTypesMap.LOGO_PRIMARY.id && !shopId) || orgData.themes.logo_url;
  yield put({ type: UPDATE_USER_IMAGE, image: logo.url });
}

export default function* loginSaga() {
  yield takeLatest(SAVE_USER_INFO, getData);
}
